export default "__VITE_ASSET__CHYtvdCl__"